/**
 * Route guards for the family museum (docs/museum-spec.md §2, §5). Layout routes: they
 * render the screen, or send the visitor to the front door (`/`) with where they were going.
 * The Office also needs a curator, and the Office PIN when one is set.
 */
import { lazy, Suspense } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router'
import { LoadingBlock } from '../design/components'
import { useSession } from '../session/SessionProvider'
import { useHousehold } from './household'

/** Shown instead of an Office screen until the PIN is entered (the Office's own component). */
const OfficePin = lazy(() => import('./office/OfficePin'))

export interface DoorNotice {
  next: string
}

export function RequireHousehold() {
  const { status } = useSession()
  const household = useHousehold()
  const location = useLocation()
  if (!household && status === 'loading') return <LoadingBlock />
  if (!household) {
    const next = `${location.pathname}${location.search}`
    return <Navigate to="/" replace state={{ next } satisfies DoorNotice} />
  }
  return <Outlet />
}

export function RequireCurator() {
  const { status } = useSession()
  const household = useHousehold()
  const location = useLocation()
  if (!household && status === 'loading') return <LoadingBlock />
  if (!household) {
    const next = `${location.pathname}${location.search}`
    return <Navigate to="/" replace state={{ next } satisfies DoorNotice} />
  }
  if (!household.can.curate && !household.can.contribute) return <Navigate to="/m" replace />
  if (household.can.curate && !household.officeOpen) {
    return (
      <Suspense fallback={<LoadingBlock />}>
        <OfficePin />
      </Suspense>
    )
  }
  return <Outlet />
}
